{
  "COMMON": {
    "LOADING": "Cargando…",
    "ERROR_CODE": {
      "ALXXX": "En este momento, no podemos encontrar opciones de vuelo alternativas. Elige otra opción o vuelve a intentarlo más tarde. También puedes contactarte con nuestro servicio de atención al cliente a través de <a href='{{link}}' target='_blank'>este formulario.</a> [Código de error {{errorCode}}]",
      "COXXX_1": "No podemos continuar con tu reservación en este momento. Vuelve a intentarlo más tarde. [Código de error {{errorCode}}]",
      "COXXX_2": "No podemos identificar tu reservación en este momento. Inténtalo de nuevo más tarde o contáctate con nuestro servicio de atención al cliente a través de <a href='{{link}}' target='_blank'>este formulario.</a> [Código de error {{errorCode}}]",
      "DIXXX": "No podemos continuar con tu solicitud en este momento. Inténtalo de nuevo más tarde o contáctate con nuestro servicio de atención al cliente a través de <a href='{{link}}' target='_blank'>este formulario.</a> [Código de error {{errorCode}}]",
      "EMXXX": "Lamentamos que no se haya podido enviar el correo electrónico. Vuelve a intentarlo más tarde. [Código de error {{errorCode}}]",
      "EXXXX": "No podemos continuar con tu solicitud en este momento. Inténtalo de nuevo más tarde o contáctate con nuestro servicio de atención al cliente a través de <a href='{{link}}' target='_blank'>este formulario.</a> [Código de error {{errorCode}}]",
      "EX115": "No podemos continuar con tu solicitud en este momento. Inténtalo de nuevo en 15 minutos contáctate con nuestro servicio de atención al cliente a través de <a href='{{link}}' target='_blank'>este formulario.</a> [Código de error {{errorCode}}]",
      "EX197": "Lamentamos las molestias, pero ocurrió un error al emitir tu reembolso. Inténtalo de nuevo o contáctate con nuestro servicio de atención al cliente a través de <a href='{{link}}' target='_blank'>este formulario.</a>",
      "EX503": "Estamos registrando una interrupción del servicio, pero pronto se resolverá. Inténtalo de nuevo en unos minutos o contáctate con nuestro servicio de atención al cliente a través de <a href='{{link}}' target='_blank'>este formulario.</a>",
      "EX401": "Tu sesión caducó. Actualiza la página e inténtalo de nuevo. Si el problema persiste, contáctate con nuestro servicio de atención al cliente a través de <a href='{{link}}' target='_blank'>este formulario.</a>",
      "OFXXX": "No podemos continuar con tu reservación en este momento. Vuelve a intentarlo más tarde. [Código de error {{errorCode}}]",
      "SEXXX": "No podemos continuar con tu reservación en este momento. Vuelve a intentarlo más tarde. [Código de error {{errorCode}}]",
      "SGXXX": "No podemos continuar con tu solicitud en este momento. Inténtalo de nuevo más tarde o contáctate con nuestro servicio de atención al cliente a través de <a href='{{link}}' target='_blank'>este formulario.</a> [Código de error {{errorCode}}]",
      "SHXXX": "En este momento, no podemos encontrar opciones de vuelo alternativas. Elige otra opción o vuelve a intentarlo más tarde. También puedes contactarte con nuestro servicio de atención al cliente a través de <a href='{{link}}' target='_blank'>este formulario.</a> [Código de error {{errorCode}}]",
      "RFXXX": "No podemos continuar con tu solicitud en este momento. Inténtalo de nuevo más tarde o contáctate con nuestro servicio de atención al cliente a través de <a href='{{link}}' target='_blank'>este formulario.</a> [Código de error {{errorCode}}]",
      "REBOOKING_TIMED_OUT": "La solicitud de reprogramación venció, pero aún estamos procesando tu reprogramación. Si no recibes ningún correo electrónico de confirmación en unos minutos, inténtalo de nuevo más tarde o contáctate con nuestro equipo de atención al cliente a través de <a href='{{link}}' target='_blank'>este formulario.</a>"
    },
    "SPREEDLY_ERROR_CODE": {
      "ACCOUNT_INACTIVE": "No se pudo procesar el pago. Asegúrate de que estás utilizando una tarjeta de prueba válida o contáctate con el equipo de atención al cliente a través de <a href='{{link}}' target='_blank'>este formulario</a>.",
      "BLANK": "Falta un campo obligatorio. Completa todos los datos de pago requeridos e inténtalo de nuevo.",
      "INVALID": "La información de pago que ingresaste no es válida. Comprueba los campos especificados e inténtalo de nuevo.",
      "BLANK_CARD_TYPE": "El número de tarjeta de crédito que ingresaste no es válido. Comprueba el número de tarjeta e inténtalo de nuevo.",
      "EXPIRED": "El método de pago que ingresaste está vencido. Utiliza un método de pago en vigor e inténtalo de nuevo.",
      "UNKNOWN_REFERRER": "No pudimos verificar el origen de tu solicitud de pago. Inténtalo de nuevo o contáctate con el equipo de atención al cliente a través de <a href='{{link}}' target='_blank'>este formulario</a>.",
      "INVALID_REFERRER": "No se pudo procesar la solicitud de pago debido a un problema de seguridad. Inténtalo de nuevo o contáctate con el equipo de atención al cliente a través de <a href='{{link}}' target='_blank'>este formulario</a>.",
      "INVALID_ENVIRONMENT_KEY_PARAMETER": "Ocurrió un error inesperado. Contáctate con el equipo de atención al cliente a través de <a href='{{link}}' target='_blank'>este formulario</a>."
    },
    "BUTTON": {
      "CONTINUE": "Continuar",
      "BACK": "Atrás",
      "CLOSE": "Cerrar"
    },
    "PRODUCT_NAME": "Protección por interrupción de vuelo",
    "PRODUCT_NAME_FLYADEAL": "Protección prémium por interrupción de vuelo",
    "FLIGHT_INFORMATIONS": {
      "LAYOVER": "{{time}} de escala en {{airportName}} ({{airportCode}})",
      "BOOKING_REFERENCE": "Referencia de la reservación: {{pnrReference}}",
      "STATUS": {
        "CANCELLED": "Cancelada",
        "DELAYED": "Retrasado",
        "FLOWN": "En vuelo",
        "BOARDED": "Abordado",
        "CONFIRMED": "Confirmado"
      },
      "CABIN": {
        "ECONOMY": "Económica",
        "PREMIUM_ECONOMY": "Económica prémium",
        "BUSINESS": "Ejecutiva",
        "FIRST": "Primera clase"
      },
      "NO_STOP": "Directo",
      "STOP": {
        "ZERO": "{{count}} escalas en {{destinations}}",
        "ONE": "{{count}} escala en {{destinations}}",
        "TWO": "{{count}} escalas en {{destinations}}",
        "FEW": "{{count}} escalas en {{destinations}}",
        "MANY": "{{count}} escalas en {{destinations}}",
        "OTHER": "{{count}} escalas en {{destinations}}"
      },
      "FLIGHT": "Vuelo",
      "OUTBOUND_FLIGHT": "Vuelo de ida",
      "INBOUND_FLIGHT": "Vuelo de regreso",
      "REBOOKED_BY_AIRLINE": "Reprogramado por {{partnerName}}",
      "PASSENGER_TYPE": {
        "ADULT": {
          "ZERO": "{{count}} adultos",
          "ONE": "{{count}} adulto",
          "TWO": "{{count}} adultos",
          "FEW": "{{count}} adultos",
          "MANY": "{{count}} adultos",
          "OTHER": "{{count}} adultos"
        },
        "CHILD": {
          "ZERO": "{{count}} niños",
          "ONE": "{{count}} niño",
          "TWO": "{{count}} niños",
          "FEW": "{{count}} niños",
          "MANY": "{{count}} niños",
          "OTHER": "{{count}} niños"
        },
        "SEATED_INFANT": {
          "ZERO": "{{count}} bebés en asientos",
          "ONE": "{{count}} bebé en asiento",
          "TWO": "{{count}} bebés en asientos",
          "FEW": "{{count}} bebés en asientos",
          "MANY": "{{count}} bebés en asientos",
          "OTHER": "{{count}} bebés en asientos"
        },
        "LAP_INFANT": {
          "ZERO": "{{count}} bebés en brazos",
          "ONE": "{{count}} bebé en brazos",
          "TWO": "{{count}} bebés en brazos",
          "FEW": "{{count}} bebés en brazos",
          "MANY": "{{count}} bebés en brazos",
          "OTHER": "{{count}} bebés en brazos"
        }
      }
    },
    "REFUND": {
      "DEFAULT_HEADER": {
        "TITLE": "Obtén un reembolso",
        "SUBTITLE": "Recibirás un reembolso en efectivo de <b>{{amount}}</b>: el 100 % del monto de tu reservación cubierta. No se realizará ningún cambio en tu reservación con {{partnerName}}, por lo que también mantendrás tu itinerario de vuelo actual.<br /><br />Vamos a confirmar tu información para que podamos procesar tu reembolso."
      },
      "CONFIRMATION_HEADER": {
        "TITLE": "¡Excelente! Tu reembolso de <b>{{amount}}</b> se está procesando.",
        "SUBTITLE": "En breve te enviaremos un correo electrónico de confirmación a <b>{{email}}</b>. Aún tienes la reservación del vuelo original. Gracias por utilizar {{productName}}."
      },
      "FORM_HEADER": {
        "PERSONAL_INFORMATION": "Información personal",
        "HOME_ADDRESS_INFORMATION": "Dirección Residencial"
      },
      "FORM": {
        "FIRST_NAME": "Nombre",
        "LAST_NAME": "Apellido",
        "ADDRESS_LINE_1": "Dirección Línea 1",
        "ADDRESS_LINE_2": "Dirección Línea 2 (opcional)",
        "CITY": "Ciudad",
        "COUNTRY": "País",
        "STATE": "Estado/Provincia",
        "ZIP": "Código postal"
      }
    },
    "GENDER": {
      "MALE": "Masculino",
      "FEMALE": "Femenino",
      "UNDISCLOSED": "No divulgado",
      "UNSPECIFIED": "Sin especificar"
    }
  },
  "HOME": {
    "CONTRACT_ALREADY_REFUNDED": "Tu solicitud de cancelación ya se tuvo en cuenta y tu reembolso está en curso. Si necesitas ayuda, contáctate con nuestro equipo de atención al cliente a través de <a href='{{link}}' target='_blank'>este formulario.</a>",
    "NO_DISRUPTION": "No se encontró ningún vuelo retrasado o cancelado."
  },
  "NOT_FOUND": {
    "TITLE": "No encontramos la página",
    "MESSAGE": "Lo sentimos. No se puede encontrar la página que buscas.",
    "GO_HOME": "Ir a la página de Inicio"
  },
  "SERVICE_DISRUPTION_STEP": {
    "TITLE": "Servicio no disponible temporalmente",
    "MESSAGE": "Estamos registrando una interrupción del servicio, pero pronto se resolverá.",
    "TRY_AGAIN": "Inténtalo de nuevo en unos minutos.",
    "CONTACT_CUSTOMER_SUPPORT": "Contactar con Atención al Cliente"
  },
  "FLIGHT_INFORMATIONS": {
    "NOT_ELIGIBLE": "Estamos monitoreando tu vuelo. Regresa aquí si hay un retraso de más de {{minMinutesDelay}} minutos o una cancelación durante las {{maxHoursBeforeDeparture}} horas previas a la salida.",
    "CHOICE_SELECTION": "¿Qué te gustaría hacer?",
    "REBOOK": {
      "TITLE": "Reprogramar vuelo",
      "DESC": "Puedes optar por reprogramar tu vuelo con cualquier aerolínea y seleccionar entre los vuelos que salen hoy o mañana."
    },
    "REFUND": {
      "TITLE": "Obtén un reembolso y mantén tu itinerario",
      "DESC": "Si las opciones para reprogramar el vuelo no satisfacen tus necesidades, obtén un reembolso de <b>{{amount}}</b> y mantén el vuelo que se vio afectado por la interrupción."
    }
  },
  "PRODUCT_INFORMATIONS": {
    "PRODUCT_INFO": "Debido a que compraste {{productName}}, tienes derecho a reprogramar tu vuelo o, si no te satisfacen las opciones para reprogramarlo, puedes obtener un reembolso si tu vuelo se canceló o se retrasó más de {{minMinutesDelay}} minutos durante las {{maxHoursBeforeDeparture}} horas previas a la salida.",
    "PRODUCT_INFO_HOURS": "Como compraste la {{productName}}, tienes derecho a una reprogramación o, si no estás conforme con nuestras opciones de reprogramación, a un reembolso si tu vuelo se cancela o se retrasa más de {{minMinutesDelay}} horas dentro de las {{maxHoursBeforeDeparture}} horas previas a la salida."
  },
  "SLICE_DETAILS_DIALOG": {
    "TITLE": "Vuelo de ida a {{destination}}"
  },
  "SLICE_INFORMATIONS": {
    "ELIGIBLE_FOR_REBOOKING": "Cumple con los requisitos para reprogramar",
    "NOT_ELIGIBLE_FOR_REBOOKING": "No cumple con los requisitos para reprogramar"
  },
  "SEND_VERIFICATION_CODE_STEP": {
    "SEND_VERIFICATION_TITLE": "Debemos asegurarnos de realmente eres tú.",
    "SEND_VERIFICATION_TEXT": "Te enviaremos un código al correo electrónico que usaste cuando reservaste tu vuelo.",
    "BUTTON": {
      "SEND_VERIFICATION_CODE": "Enviar código"
    }
  },
  "CHECK_VERIFICATION_CODE_STEP": {
    "CHECK_VERIFICATION_TITLE": "Debemos asegurarnos de realmente eres tú.",
    "CHECK_VERIFICATION_TEXT": "Acabamos de enviar un correo electrónico con un código de verificación a {{email}}.",
    "BUTTON": {
      "RESEND_VERIFICATION_CODE": "Enviar un nuevo código"
    }
  },
  "HYPERWALLET_FORM_STEP": {
    "FORM": {
      "MIDDLE_NAME": "Segundo nombre (opcional)",
      "DATE_OF_BIRTH": "Fecha de nacimiento"
    }
  },
  "HYPERWALLET_REFUND_STEP": {
    "RECEIVE_AMOUNT_TITLE": "¿Cómo quieres recibir el reembolso?"
  },
  "SPREEDLY_FORM_STEP": {
    "CARD_INFORMATION": "Información de la tarjeta",
    "FORM": {
      "FULL_NAME": "Nombre completo",
      "CARD_NUMBER": "Número de la tarjeta",
      "EXPIRATION_MONTH": "Mes de vencimiento",
      "EXPIRATION_YEAR": "Año de vencimiento",
      "CVV": "CVV"
    },
    "BUTTON": {
      "REDIRECT_TO_BANK_TRANSFER": "No tengo una tarjeta de crédito"
    }
  },
  "BANK_TRANSFER_FORM_STEP": {
    "DESC": "Te enviaremos el reembolso a tu cuenta bancaria.",
    "FORM": {
      "BANK_INFORMATION": "Información de la cuenta bancaria",
      "ACCOUNT_NUMBER": "IBAN/Número de cuenta bancaria",
      "BANK_ID": "Código SWIFT/BIC",
      "ACCOUNT_HOLDER_INFORMATION": "Información del titular de la cuenta",
      "VALIDATION": {
        "REQUIRED": "Este campo es obligatorio",
        "INVALID_IBAN": "Ingresa un código IBAN válido",
        "INVALID_BIC": "Ingresa un código SWIFT/BIC válido",
        "formValidationAccountNumberRequired": "Ingresa tu número de cuenta bancaria.",
        "formValidationBankCodeRequired": "Ingresa tu código bancario.",
        "formValidationBankCodeLength": "El código bancario debe tener entre 8 y 11 caracteres.",
        "formValidationBankCodeFirstChars": "El código bancario debe comenzar con 4 letras.",
        "formValidationBankCodeCountryUnsupported": "El país al que pertenece este código bancario no admite transferencias internacionales.",
        "formValidationBankCodeCountryInvalid": "El código de país en tu código bancario no es válido.",
        "formValidationBankCodeLocationInvalid": "El código de ubicación en tu código bancario no es válido.",
        "formValidationBankCodeBranchInvalid": "El código de sucursal en tu código bancario no es válido.",
        "formValidationIbanCharsInvalid": "Tu número de cuenta bancaria contiene caracteres no válidos. Usa solo letras y números.",
        "formValidationIbanCountryInvalid": "Tu número de cuenta bancaria debe comenzar con un código de país válido.",
        "formValidationIbanCountryUnsupported": "El país al que pertenece este número de cuenta bancaria no admite transferencias internacionales.",
        "formValidationIbanLengthInvalid": "Tu número de cuenta bancaria tiene una longitud no válida para este país.",
        "formValidationIbanChecksumInvalid": "Tu número de cuenta bancaria no es válido. Revísalo e inténtalo de nuevo.",
        "formValidationIbanBicCountryMismatch": "El país en tu número de cuenta bancaria no coincide con el país en tu código bancario."
      }
    }
  },
  "PAYOUT_ERROR_STEP": {
    "TITLE": "No pudimos procesar tu solicitud de {{productName}}",
    "SUBTITLE": "Lamentamos las molestias, pero ocurrió un error al emitir tu reembolso. Haz clic en <b>Continuar</b> para revisar nuestras opciones para procesar el reembolso. Si tienes alguna dificultad, contáctate con nuestro servicio de atención al cliente a través de <a href='{{link}}' target='_blank'>este formulario.</a>",
    "NO_PAYOUT_OPTIONS": "Contáctate con nuestro equipo de atención al cliente mediante <a href='{{link}}' target='_blank'>este formulario.</a>"
  },
  "REBOOKING_CONFIRMATION_STEP": {
    "TITLE": "¡Relájate! Tu nueva reservación está confirmada.",
    "SUBTITLE": "En breve enviaremos un correo electrónico de confirmación a {{email}}. Gracias por utilizar {{productName}}.",
    "YOUR_NEW_FLIGHT": "Tu nuevo vuelo",
    "ROUND_TRIP_WARNING": "Te recomendamos encarecidamente que confirmes directamente con Frontier Airlines que los vuelos restantes en tu reservación, incluidos los vuelos de regreso, no se cancelarán si rechazas u omites las opciones de cambio de reservación ofrecidas por Frontier Airlines."
  },
  "REBOOKING_FORM_STEP": {
    "TITLE": "Información sobre los pasajeros",
    "SUBTITLE": "Vamos a confirmar tu información antes de reprogramar tu vuelo.",
    "LOADING_REBOOK": "Cambiando la reservación…",
    "PASSENGER": "Pasajero {{index}}",
    "BUTTON": {
      "SUBMIT": "Confirmar y cambiar la reservación"
    },
    "TRAVEL_DOCUMENT": "Documento de viaje",
    "FORM": {
      "FIRST_NAME": "Nombre",
      "LAST_NAME": "Apellido",
      "GENDER": "Género",
      "DOCUMENT_TYPE": "Tipo de documento",
      "PASSPORT_NUMBER": "Número de pasaporte",
      "COUNTRY_ISSUANCE": "País emisor",
      "NATIONALITY": "Nacionalidad",
      "ISSUANCE_DATE": "Fecha de emisión",
      "EXPIRATION_DATE": "Fecha de expiración",
      "DATE_OF_BIRTH": "Fecha de nacimiento",
      "NATIONAL_ID_NUMBER": "Número de identificación nacional"
    },
    "DOCUMENT_TYPES": {
      "passport": "Pasaporte",
      "national_id": "Documento nacional de identidad"
    }
  },
  "REBOOKING_REVIEW_STEP": {
    "TITLE": "Reprograma tu vuelo",
    "SUBTITLE": "Puedes optar por reprogramar tu vuelo gratis (hasta {{serviceCap}} por pasajero), al elegir entre vuelos del mismo día o del día siguiente. Si eliges un nuevo vuelo, se cancelará tu vuelo inicial de {{partnerName}}, pero mantendrás tus vuelos de regreso, si corresponde.",
    "LOADING_REBOOK": "Cambiando la reservación…",
    "CHOICE_SUMMARY": "Aquí tienes un resumen de tu selección",
    "DIFFERENT_AIRPORT": "Revisa tu itinerario, ya que seleccionaste un itinerario de vuelo que sale o llega a un aeropuerto diferente al de tu vuelo original."
  },
  "REBOOKING_SEARCH_ALTERNATIVES_STEP": {
    "TITLE": "Reprograma tu vuelo",
    "SUBTITLE": "Puedes optar por reprogramar tu vuelo gratis (hasta {{serviceCap}} por pasajero), al elegir entre vuelos del mismo día o del día siguiente. Si eliges un nuevo vuelo, se cancelará tu vuelo inicial de {{partnerName}}, pero mantendrás tus vuelos de regreso, si corresponde.",
    "LOADING_REBOOK": "Cambiando la reservación…",
    "LOADING_ALTERNATIVES": "Espera mientras cargamos tus opciones de cambio de reservación",
    "ONE_MORE_ALTERNATIVE": "{{nbAlternative}} alternativa más",
    "MORE_ALTERNATIVES": "{{nbAlternative}} alternativas más",
    "NO_ALTERNATIVE": "Lo sentimos, actualmente no hay opciones de vuelo disponibles para esta fecha de salida. Puedes elegir una de las siguientes opciones: ",
    "BAGS_TITLE": "¿Tienes equipaje registrado?",
    "BUTTON": {
      "YES": "Sí",
      "NO": "No",
      "GO_TO_REFUND_FLOW": "Elige nuestra opción de reembolso",
      "SEARCH_FOR_OTHER_DAY": "Busca vuelos un día antes o después"
    },
    "OUTBOUND": "Ida hacia {{destination}}",
    "NO_STOP": "Directo",
    "STOP": {
      "ZERO": "{{count}} escalas",
      "ONE": "{{count}} escala",
      "TWO": "{{count}} escalas",
      "FEW": "{{count}} escalas",
      "MANY": "{{count}} escalas",
      "OTHER": "{{count}} escalas"
    },
    "SEE_OTHER_AIRLINES": "Mostrar aerolíneas adicionales"
  },
  "WARNING_BAGS_DIALOG": {
    "TITLE": "Aviso importante sobre el equipaje facturado",
    "DESC": "Dado que registraste tu equipaje con la aerolínea para el vuelo que se vio afectado por la interrupción, lo descargarán y deberás registrarlo otra vez en el nuevo vuelo. Para ello, visita el mostrador de facturación de la aerolínea en el aeropuerto.<br /><br />No podemos garantizarte que descargarán el equipaje a tiempo para facturarlo en el nuevo vuelo.",
    "DESC_FLYADEAL": "Dado que registraste tu equipaje con la aerolínea para el vuelo que se vio afectado por la interrupción, lo descargarán y deberás registrarlo otra vez en el nuevo vuelo. Para ello, visita el servicio de atención al cliente de la aerolínea o el servicio de reclamo de equipaje en el aeropuerto para obtener tu equipaje. <br /><br />Es tu responsabilidad recoger y facturar el equipaje en el nuevo vuelo a tiempo.",
    "BUTTON": {
      "REFUND": "Mantener el vuelo y obtener un reembolso",
      "REBOOK": "Reprogramar y gestionar mi equipaje"
    }
  },
  "ALTERNATIVE_DETAILS_DIALOG": {
    "TITLE": "Vuelo de ida a {{destination}}",
    "BUTTON": {
      "SUBMIT": "Seleccionar este vuelo"
    }
  }
}
